<template>
  <v-dialog v-model="dialog" persistent max-width="1600px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Lokalita</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="2">
                <v-text-field
                  label="Geology ID*"
                  v-model="lokalita.LOKID"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Lokalita*"
                  v-model="lokalita.Name"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  label="Katastrálne územie"
                  v-model="lokalita.KUID"
                  :items="kuitems"
                  item-text="NM5"
                  item-value="ObjectID"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.NM5"></v-list-item-title>
                      <v-list-item-subtitle>
                        <b>Obec:</b> {{ item.NM4 }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <b>Okres:</b> {{ item.NM3 }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <!--v-col cols="3">
                <v-autocomplete
                  label="Číslo map.listu 1:10 000"
                  v-model="lokalita.ZM10ID"
                  :items="zm10items"
                  item-text="Zmsm"
                  item-value="ObjectID"
                ></v-autocomplete>
              </v-col>
              <v-col-- cols="3">
                <v-autocomplete
                  label="Číslo map.listu 1:50 000"
                  v-model="lokalita.ZM50ID"
                  :items="zm50items"
                  item-text="Zmsm"
                  item-value="ObjectID"
                ></v-autocomplete>
              </v-col-->
              <v-col cols="3">
                <date-picker
                  v-model="lokalita.DatumOd"
                  label="Dátum od"
                  name="datumOd"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <date-picker
                  v-model="lokalita.DatumDo"
                  label="Dátum do"
                  name="datumDo"
                ></date-picker>
              </v-col>
              <v-col cols="6"> </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Názov inž.geol. regiónu"
                  v-model="lokalita.IgReg"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Názov inž.geol. oblasti"
                  v-model="lokalita.IgObl"
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  label="Plocha"
                  type="number"
                  v-model.number="lokalita.Plocha"
                  clearable
                  suffix="m2"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Objem"
                  type="number"
                  v-model.number="lokalita.Objem"
                  clearable
                  suffix="m3"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Nadmorská výška od"
                  type="number"
                  v-model.number="lokalita.Nadm1"
                  clearable
                  suffix="mnm"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Nadmorská výška do"
                  type="number"
                  v-model.number="lokalita.Nadm2"
                  clearable
                  suffix="mnm"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  label="Popis"
                  v-model="lokalita.Popis"
                  rows="5"
                ></v-textarea>
              </v-col>

              <v-col cols="4">
                <v-checkbox
                  v-model="lokalita.Zobrazovat"
                  label="Zobrazovať na verejnej časti"
                ></v-checkbox>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  label="Zobrazovať od roku"
                  type="number"
                  v-model.number="lokalita.RokOd"
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  label="Zobrazovať do roku"
                  type="number"
                  v-model.number="lokalita.RokDo"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <div>
                  Literatúra
                  <v-btn icon color="green" @click="addLiteratura">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <template v-for="(lit, index) in lokalita.Literatura">
                  <div :key="index">
                    <v-combobox
                      v-model="lit.Literatura"
                      :items="literaturyItems"
                      label=""
                      dense
                      clearable
                      hide-details
                    ></v-combobox>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-container>
          <small>*indikuje povinné polia</small>
        </v-card-text>

        <v-card-actions>
          <v-btn color="alert" text @click="deleteLokalita()">Vymazať</v-btn>
          <v-btn color="primary" text @click="dialog = false">Zavrieť</v-btn>
          <v-btn color="primary" text @click="save()">Uložiť</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import DatePicker from "../components/DatePicker.vue"
import * as Miscella from "../plugins/miscella.js"

export default {
  name: "LokalitaDetail",
  components: {
    DatePicker
  },
  data: () => ({
    dialog: false,
    lokalita: {
      Nazov: "",
      skratka: "",
      id: ""
    },
    zm10items: [],
    zm50items: [],
    kuitems: [],
    literaturyItems: [],
    oldid: "",
    valid: true,
    requiredRule: [v => !!v || "Položka je povinná"],
    idRules: [v => (v && v.length === 3) || "ID musí mať tri znaky"]
  }),

  methods: {
    show: function(lok) {
      this.dialog = true
      this.lokalita = Miscella.deepCloneObject(lok)
      this.oldid = lok.ID
      console.log("EDIT LOKALITA", lok)
    },

    async save() {
      if (this.$refs.form.validate()) {
        try {
          let response = await this.$axios.post("/r/lokalita", {
            oldID: this.oldid,
            lokalita: this.lokalita
          })
          if (response.status === 200) {
            this.$store.commit("message", "Lokalita uložená")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      } else {
        this.$store.commit("alert", "Vo formulári sú chyby")
      }
    },

    async deleteLokalita() {
      if (confirm("Naozaj vymazať lokalitu z databázy ?")) {
        try {
          let response = await this.$axios.delete(
            "/r/lokalita/" + this.lokalita.ID
          )
          if (response.status === 200) {
            this.$store.commit("message", "Lokalita je vymazaná.")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    },
    addLiteratura: function() {
      this.lokalita.Literatura.push({ ID: null, Literatura: "" })
    },
    deleteLiteratura: function(aIndex) {
      Miscella.remove(this.lokalita.Literatura, aIndex)
    },
    fetchZM10: async function() {
      try {
        let response = await this.$axios.get("/zm10")
        if (response.status === 200) {
          this.zm10items = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    fetchZM50: async function() {
      try {
        let response = await this.$axios.get("/zm50")
        if (response.status === 200) {
          this.zm50items = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    fetchKU: async function() {
      try {
        let response = await this.$axios.get("/ku")
        if (response.status === 200) {
          this.kuitems = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    fetchLiteratury: async function() {
      try {
        let response = await this.$axios.get("/r/literatury")
        if (response.status === 200) {
          this.literaturyItems = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    }
  },
  mounted: async function() {
    this.fetchZM10()
    this.fetchZM50()
    this.fetchKU()
    await this.$store.dispatch("fetchme", this.$axios)
    this.fetchLiteratury()
  }
}
</script>
